import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e1c58de0"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  key: 1,
  style: {
    "width": "50%",
    "height": "100%"
  }
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "dash-line"
}, null, -1));
const _hoisted_6 = {
  key: 3,
  style: {
    "width": "50%"
  }
};
const _hoisted_7 = {
  key: 0
};
const _hoisted_8 = {
  key: 0
};
const _hoisted_9 = {
  key: 0
};
const _hoisted_10 = {
  key: 0,
  style: {
    "display": "flex",
    "align-items": "center",
    "width": "100%",
    "justify-content": "center"
  }
};
const _hoisted_11 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_AppIcon = _resolveComponent("AppIcon");
  const _component_date_value = _resolveComponent("date-value");
  const _component_value_element = _resolveComponent("value-element");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_segmented_bar = _resolveComponent("segmented-bar");
  const _component_dashed_position_bar = _resolveComponent("dashed-position-bar");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_wrap_table_with_show_more = _resolveComponent("wrap-table-with-show-more");
  const _component_table_with_title = _resolveComponent("table-with-title");
  return _openBlock(), _createBlock(_component_table_with_title, {
    title: "Evolution",
    class: "performance-period-table",
    onDownload: $options.downloadPerformancePeriodCSV,
    onGoogleSheetDownload: $options.downloadPerformanceGoogleSheet,
    onCopy: $options.copyPerformancePeriodCSV,
    fields: $data.fields,
    loading: $props.loading
  }, {
    "period-selector": _withCtx(() => [_renderSlot(_ctx.$slots, "period-selector", {}, undefined, true)]),
    default: _withCtx(() => [_createVNode(_component_wrap_table_with_show_more, {
      modelValue: $options.period_pager,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.period_pager = $event),
      period: _ctx.period
    }, {
      default: _withCtx(() => [_createVNode(_component_b_table_lite, {
        class: "lite-table lite-table-hoverable period-table performance-table",
        fields: $data.fields,
        bordered: "",
        responsive: "",
        fixed: "",
        items: $options.items,
        "sticky-header": true,
        tbodyTrClass: item => _ctx.handleRowClass(item, $options.items),
        "no-border-collapse": "",
        onRowClicked: $options.handleRowClick
      }, {
        "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
          class: "headers"
        }, {
          default: _withCtx(() => [_createVNode(_component_b_th, {
            colspan: "1",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "1",
            "sticky-column": "",
            style: {
              borderRight: 'none'
            }
          }), _createVNode(_component_b_th, {
            colspan: "2"
          }), _createVNode(_component_b_th, {
            colspan: "3",
            class: "acquisitions left-embrace right-embrace",
            style: {
              color: '#2172E1',
              backgroundColor: '#EDF5FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Acquisitions")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "2",
            class: "churn left-embrace right-embrace",
            style: {
              color: '#D7AA0F',
              backgroundColor: '#FAF8EF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Churn")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "1",
            class: "reactivation left-embrace right-embrace",
            style: {
              color: '#068481',
              backgroundColor: '#F1F9F9'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Reactivation")]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_b_th, {
            colspan: "6",
            class: "engagement left-embrace right-embrace",
            style: {
              color: '#9447FF',
              backgroundColor: '#F6F2FF'
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_hug_value, null, {
              default: _withCtx(() => [_createTextVNode("Engagement")]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        "head()": _withCtx(col => [_createVNode(_component_flex_row, {
          id: `performance-period-table-${col?.column}`,
          styles: {
            justifyContent: col.field.justify,
            ...col.field.thStyle,
            'line-height': '130%'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
            target: `performance-period-table-${col?.column}`
          }, {
            title: _withCtx(() => [_createElementVNode("div", {
              innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
            }, null, 8, _hoisted_1)]),
            content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
            default: _withCtx(() => [_createElementVNode("div", {
              innerHTML: col?.column === 'period_agg' ? $options.getPeriodColumnTitle : col?.label,
              class: "title"
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["target"])]),
          _: 2
        }, 1032, ["id", "styles"])]),
        "cell(selector)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading
        }, {
          default: _withCtx(() => [_createVNode(_component_AppIcon, {
            icon: `zoom-${row.item.selected ? 'out' : 'in'}`,
            color: row.item.selected ? null : '#ADADAD',
            size: 16
          }, null, 8, ["icon", "color"])]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(customer_period_agg)": _withCtx(row => [_createVNode(_component_date_value, {
          value: row.item?.period_agg,
          format: $options.getDateValueFormat,
          styles: {
            justifyContent: 'flex-start',
            ..._ctx.activateDateValueStyles(row)
          },
          loading: $props.loading
        }, null, 8, ["value", "format", "styles", "loading"])]),
        "cell(active_customers_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.active_customers_12m,
              background: "#FFF1E9",
              borderColor: "#F27123",
              min: $options.minMax?.active_customers_12m?.min,
              max: $options.minMax?.active_customers_12m?.max,
              loading: $props.loading,
              align: "left",
              style: {
                "padding": "0px 8px 0px 0px"
              }
            }, {
              default: _withCtx(() => [row.item?.active_customers_12m == null ? (_openBlock(), _createElementBlock("div", _hoisted_3, "--")) : (_openBlock(), _createBlock(_component_value_element, {
                key: 1,
                value: $options.customerNumberFormat(row.item?.active_customers_12m)
              }, null, 8, ["value"]))]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, [row.item?.new_customers_month != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`active_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(monthly_net_acquisition)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 8px",
            "width": "100%"
          }
        }, {
          default: _withCtx(() => [row.item?.monthly_net_acquisition < 0 ? (_openBlock(), _createBlock(_component_overlap_bar_value, {
            key: 0,
            value: -row.item?.monthly_net_acquisition,
            background: "#FFEBEC",
            borderColor: "#F5A3A7",
            min: $options.minMax?.monthly_net_acquisition?.min,
            max: Math.max($options.minMax?.monthly_net_acquisition?.max, Math.abs($options.minMax?.monthly_net_acquisition?.negativeMin)),
            loading: $props.loading,
            align: "right",
            style: {
              "width": "50%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.monthly_net_acquisition,
              allowPrecisionModification: true,
              charCount: 5,
              precision: "0",
              style: {
                "width": "100%"
              },
              showSign: ""
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])) : (_openBlock(), _createElementBlock("div", _hoisted_4)), _hoisted_5, row.item?.monthly_net_acquisition >= 0 ? (_openBlock(), _createBlock(_component_overlap_bar_value, {
            key: 2,
            value: row.item?.monthly_net_acquisition,
            background: "#DEFBE6",
            borderColor: "#47D16C",
            min: $options.minMax?.monthly_net_acquisition?.min,
            max: Math.max($options.minMax?.monthly_net_acquisition?.max, Math.abs($options.minMax?.monthly_net_acquisition?.negativeMin)),
            loading: $props.loading,
            align: "left",
            style: {
              "width": "50%",
              "height": "100%"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.monthly_net_acquisition,
              allowPrecisionModification: true,
              charCount: 5,
              precision: "0",
              style: {
                "width": "100%"
              },
              showSign: ""
            }, null, 8, ["value"])]),
            _: 2
          }, 1032, ["value", "min", "max", "loading"])) : (_openBlock(), _createElementBlock("div", _hoisted_6))]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(new_customers_month)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.new_customers_month,
              background: "#EDF5FF",
              borderColor: "#2172E1",
              min: $options.minMax?.new_customers_month?.min,
              max: $options.minMax?.new_customers_month?.max,
              loading: $props.loading,
              align: "left"
            }, {
              default: _withCtx(() => [row.item?.new_customers_month == null ? (_openBlock(), _createElementBlock("div", _hoisted_7, "--")) : (_openBlock(), _createBlock(_component_value_element, {
                key: 1,
                value: $options.customerNumberFormat(row.item?.new_customers_month)
              }, null, 8, ["value"]))]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, [row.item?.new_customers_month != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`new_customers_month${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(pct_new_customers)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.pct_new_customers,
              color: _ctx.color,
              charCount: $options.minMax?.pct_new_customers?.min <= 0.009 ? $options.maxCharCount?.percentage?.pct_new_customers + 2 : $options.maxCharCount?.percentage?.pct_new_customers,
              precision: Math.abs(row.item?.pct_new_customers) >= 0.001 && Math.abs(row.item?.pct_new_customers) <= 0.009 ? 1 : 0
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, [row.item?.pct_new_customers != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`pct_new_customers${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(cac)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, null, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`cac${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`cac${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`cac${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`cac${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`cac${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`cac${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`cac${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.cac,
              min: 0,
              color: "#ADCDFF",
              max: $options.minMax?.cac?.max,
              loading: $props.loading,
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.cac,
                allowPrecisionModification: true,
                charCount: $options.maxCharCount?.currency?.cac,
                precision: "1",
                style: {
                  "width": "100%"
                }
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(churned_customers_12m_month)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.churned_customers_12m_month,
              background: "#FDF8E7",
              borderColor: "#D7AA0F",
              min: $options.minMax?.churned_customers_12m_month?.min,
              max: $options.minMax?.churned_customers_12m_month?.max,
              loading: $props.loading,
              align: "right"
            }, {
              default: _withCtx(() => [row.item?.churned_customers_12m_month == null ? (_openBlock(), _createElementBlock("div", _hoisted_8, " -- ")) : (_openBlock(), _createBlock(_component_value_element, {
                key: 1,
                value: `-${$options.customerNumberFormat(row.item?.churned_customers_12m_month)}`
              }, null, 8, ["value"]))]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, [row.item?.churned_customers_12m_month != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`churned_customers_12m_month${$data.evolCategory[_ctx.periodCategory]}`],
              change: "negative"
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`churned_customers_12m_month${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`churned_customers_12m_month${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`churned_customers_12m_month${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`churned_customers_12m_month${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(pct_churned_customers_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.pct_churned_customers_12m,
              color: _ctx.color,
              charCount: $options.minMax?.pct_churned_customers_12m?.min <= 0.009 ? $options.maxCharCount?.percentage?.pct_churned_customers_12m + 2 : $options.maxCharCount?.percentage?.pct_churned_customers_12m,
              precision: Math.abs(row.item?.pct_churned_customers_12m) >= 0.001 && Math.abs(row.item?.pct_churned_customers_12m) <= 0.009 ? 1 : 0
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, [row.item?.pct_churned_customers_12m != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`],
              change: "negative"
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`pct_churned_customers_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(reactivated_customers_month)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.reactivated_customers_month,
              background: "#ECF9F9",
              borderColor: "#068481",
              min: $options.minMax?.reactivated_customers_month?.min,
              max: $options.minMax?.reactivated_customers_month?.max,
              loading: $props.loading,
              align: "left"
            }, {
              default: _withCtx(() => [row.item?.reactivated_customers_month == null ? (_openBlock(), _createElementBlock("div", _hoisted_9, " -- ")) : (_openBlock(), _createBlock(_component_value_element, {
                key: 1,
                value: $options.customerNumberFormat(row.item?.reactivated_customers_month)
              }, null, 8, ["value"]))]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, [row.item?.reactivated_customers_month != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`reactivated_customers_month${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(avg_revenue_per_active_customer_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, null, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`] * 100
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`avg_revenue_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.avg_revenue_per_active_customer_12m,
              min: 0,
              color: "#8D85E5",
              max: $options.minMax?.avg_revenue_per_active_customer_12m?.max,
              loading: $props.loading,
              tight: ""
            }, {
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.avg_revenue_per_active_customer_12m,
                allowPrecisionModification: true,
                charCount: $options.maxCharCount?.currency?.avg_revenue_per_active_customer_12m,
                precision: "1",
                style: {
                  "width": "100%"
                }
              }, null, 8, ["value", "charCount"])]),
              _: 2
            }, 1032, ["value", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(avg_aov_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_currency_value, {
              value: row.item?.avg_aov_12m,
              allowPrecisionModification: true,
              charCount: $options.maxCharCount?.currency?.avg_aov_12m,
              precision: "1",
              style: {
                "justify-content": "flex-end"
              }
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, [row.item?.avg_aov_12m != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`avg_aov_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(avg_purchase_per_active_customer_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 4px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              loading: $props.loading,
              tight: ""
            }, {
              "custom-bar": _withCtx(() => [_createVNode(_component_segmented_bar, {
                value: row.item?.avg_purchase_per_active_customer_12m ? row.item?.avg_purchase_per_active_customer_12m / 100 : 0,
                color: row.item?.avg_purchase_per_active_customer_12m ? '#E3E3E3' : '#AFACAC'
              }, null, 8, ["value", "color"])]),
              default: _withCtx(() => [row.item?.avg_purchase_per_active_customer_12m == null ? (_openBlock(), _createElementBlock("div", _hoisted_10, " -- ")) : (_openBlock(), _createBlock(_component_value_element, {
                key: 1,
                value: $options.avgCustomerPurchaseFormat(row.item?.avg_purchase_per_active_customer_12m)
              }, null, 8, ["value"]))]),
              _: 2
            }, 1032, ["loading"])]),
            _: 2
          }, [row.item?.avg_purchase_per_active_customer_12m != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`avg_purchase_per_active_customer_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(median_time_between_purchases_days_12m)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`median_time_between_purchases_days_12m${$data.evolCategory[_ctx.periodCategory]}`],
              change: "negative"
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`median_time_between_purchases_days_12m${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.maxCharCount?.percentage?.[`median_time_between_purchases_days_12m${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`median_time_between_purchases_days_12m${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`median_time_between_purchases_days_12m${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.median_time_between_purchases_days_12m ?? 0,
              color: "#9B94EB",
              loading: $props.loading,
              tight: ""
            }, {
              "custom-bar": _withCtx(() => [_createVNode(_component_dashed_position_bar, {
                value: row.item?.median_time_between_purchases_days_12m ?? 0,
                max: $options.minMax?.median_time_between_purchases_days_12m?.max,
                color: "#9B94EB"
              }, null, 8, ["value", "max"])]),
              default: _withCtx(() => [_createVNode(_component_value_element, {
                value: $options.computedMedTimePurchaseDay(row.item?.median_time_between_purchases_days_12m)
              }, null, 8, ["value"])]),
              _: 2
            }, 1032, ["value", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(pct_active_customers_12m_with_2plus_purchases)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_percentage_value, {
              value: row.item?.pct_active_customers_12m_with_2plus_purchases,
              color: _ctx.color,
              charCount: $options.minMax?.pct_active_customers_12m_with_2plus_purchases?.min <= 0.009 ? $options.maxCharCount?.percentage?.pct_active_customers_12m_with_2plus_purchases + 2 : $options.maxCharCount?.percentage?.pct_active_customers_12m_with_2plus_purchases,
              precision: Math.abs(row.item?.pct_active_customers_12m_with_2plus_purchases) >= 0.001 && Math.abs(row.item?.pct_active_customers_12m_with_2plus_purchases) <= 0.009 ? 1 : 0
            }, null, 8, ["value", "color", "charCount", "precision"])]),
            _: 2
          }, [row.item?.pct_active_customers_12m_with_2plus_purchases != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`pct_active_customers_12m_with_2plus_purchases${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        "cell(pct_revenue_subscribe_and_save_month)": _withCtx(row => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "padding": "0px 8px 0px 0px"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 0
          }, _createSlots({
            default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
              value: row.item?.pct_revenue_subscribe_and_save_month,
              background: "#F6F2FF",
              borderColor: "#F6F2FF",
              min: $options.minMax?.pct_revenue_subscribe_and_save_month?.min,
              max: $options.minMax?.pct_revenue_subscribe_and_save_month?.max,
              loading: $props.loading,
              align: "left"
            }, {
              default: _withCtx(() => [row.item?.pct_revenue_subscribe_and_save_month == null ? (_openBlock(), _createElementBlock("div", _hoisted_11, " -- ")) : _createCommentVNode("", true), _createVNode(_component_percentage_value, {
                value: row.item?.pct_revenue_subscribe_and_save_month,
                color: _ctx.color,
                charCount: $options.minMax?.pct_revenue_subscribe_and_save_month?.min <= 0.009 ? $options.maxCharCount?.percentage?.pct_revenue_subscribe_and_save_month + 2 : $options.maxCharCount?.percentage?.pct_revenue_subscribe_and_save_month,
                precision: Math.abs(row.item?.pct_revenue_subscribe_and_save_month) >= 0.001 && Math.abs(row.item?.pct_revenue_subscribe_and_save_month) <= 0.009 ? 1 : 0
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, [row.item?.pct_revenue_subscribe_and_save_month != null ? {
            name: "evolution",
            fn: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`],
                color: color,
                charCount: $options.minMax?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`]?.min <= 0.009 ? $options.maxCharCount?.percentage?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`] + 2 : $options.maxCharCount?.percentage?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`],
                precision: Math.abs(row.item?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`]) >= 0.001 && Math.abs(row.item?.[`pct_revenue_subscribe_and_save_month${$data.evolCategory[_ctx.periodCategory]}`]) <= 0.009 ? 1 : 0,
                showSign: "",
                pp: ""
              }, null, 8, ["value", "color", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value"])]),
            key: "0"
          } : undefined]), 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 1
      }, 8, ["fields", "items", "tbodyTrClass", "onRowClicked"])]),
      _: 1
    }, 8, ["modelValue", "period"])]),
    _: 3
  }, 8, ["onDownload", "onGoogleSheetDownload", "onCopy", "fields", "loading"]);
}